define(function () {
  return {
    // CALL CENTER USER
    'call_center.register': "Rekisteröi uusi käyttäjä",

    'incrowd_stats.num_responders': "{{num}} Terveydenhoitoalan asiantuntijaa",
    'incrowd_stats.num_answers': "{{num}} Vastattua kysymystä",
    'incrowd_stats.time_to_complete': "{{num}} Minuuttia keskivertokyselyn täyttämiseen",

    // INCROWD
    'incrowd.about': "Tietoa",
    'incrowd.contact': "Yhteystiedot",
    'incrowd.press': "Media",
    'incrowd.careers': "Työpaikat",
    'incrowd.terms': "Ehdot",
    'incrowd.t_and_c': "Ehdot ja edellytykset",
    'incrowd.faq': "Usein kysytyt kysymykset",
    'incrowd.privacy': "Tietosuoja",
    'incrowd.copyright': "{{year}} InCrowd Inc, kaikki oikeudet pidätetään",
    'incrowd.blog': "Blogi",
    'incrowd.support': "Tuki",
    'incrowd.info.ios': "Tiesitkö, että inCrowd-tietoverkon fyysikot voivat nyt lähettää kysymyksensä suoraan kollegoilleen? Kokeile sitä nyt käyttämällä <InCrowd iOS App>-sovellusta!",
    'incrowd.refer': "Pidätkö kyselyidemme täyttämisestä? <Kutsu ystäväsi> mukaan joukkoomme jo tänään ja tienaat itsellesi 10 USD (tai vastaavan). He vastaanottavat bonuksen vastattuaan kyselyyn!",


    // GET STARTED (step 0)
    'getstarted.encourage.title': "Mikrokyselyt,",
    'getstarted.encourage.title.two': " massiivinen vaikutus",
    'getstarted.encourage.subtitle': "Liity tuhansien pätevien lääketieteen ammattilaisten joukkoon ja vaikuta uusiin tuotteisiin ja potilaiden hoitoon yksinkertaisten mikrokyselyiden kautta - me jopa maksamme siitä!",
    'getstarted.encourage.redirect_to_solutions': "Haluat oppia lisää InCrowdista, muttet ole terveydenhoitoalan ammattilainen?",
    'getstarted.actions.title': "Oletko pätevä lääketieteen ammattilainen?",
    'getstarted.actions.subtitle': "Liity tänään ja aloita tienaaminen vastaamalla terveydenhoitoon liittyviin mikrokyselyihin",
    'getstarted.button.continue': "Aloita",
    'getstarted.referral': "Rekisteröidy ansaitaksesi rahaa kyselyistä sekä saadaksesi suosittelubonuksesi käyttäjältä %{{referrerName}}",
    'getstarted.register_with.register_with': "Rekisteröidy seuraavaa kautta",
    'getstarted.register_with.email': "Tai sähköpostiosoitteellasi",

    'details.need_info_description': "Tarvitsemme joitakin tietoja tilin luomiseksi.",
    'details.profile_details': "Profiilin tiedot",
    'details.address_information': "Osoitetiedot",
    'details.professional_info': "Ammattitiedot",
    'details.heading.finally': "…ja lopuksi",
    'details.how_receive_surveys': "Miten haluat vastaanottaa kyselyitä?",

    // PROFESSION CHOICE (step 1)
    'professionchoice.encourage.title': "Perusteet",
    'professionchoice.encourage.subtitle': "Etkö näe ammattiasi? Kerro meille <täällä>, jotta voimme ilmoittaa sinulle lisättyämme ammattisi listalle.",
    // AUTHENTICATION INFORMATION (step 2)
    'authentication.encourage.title': "Kuka olet?",
    'authentication.encourage.subtitle': "InCrowd haluaa vahvistaa henkilöllisyytesi, mutta emme koskaan paljasta tai jaa henkilökohtaisia tietojasi ulkopuolisille.",
    'authentication.actions.select_notifications': "Valitse kuinka haluat vastaanottaa kyselyitämme",
    // VALIDATE IDENTITY (step 3)
    'validation.please_wait': "Odota hetki, kun vahvistamme tietosi",
    'validation.please_answer': "Ole hyvä ja vastaa seuraaviin kysymyksiin auttaaksesi meitä vahvistamaan henkilökohtaiset tietosi",
    // CONFIRMATION (final step)
    'confirmation.validation_success.title': "Vahvistus",
    'confirmation.validation_success.subtitle': "Olet nyt rekisteröitynyt, tervetuloa InCrowd iin! Saat vahvistuksen pian sähköpostitse/tekstiviestillä. Kiitos liittymisestä!",
    'confirmation.validation_error.title': "Lisätietoja Tarvitaan",
    'confirmation.validation_error.subtitle': "Anteeksi,% {userFirstName}, henkilökohtaisten tietojesi vahvistamisessa esiintyi ongelma.",
    'confirmation.actions_title': "Mitä seuraavaksi?",
    'confirmation.go_to_your_profile': "Siirry profiiliisi",
    'confirmation.validation_success.actions_subtitle': "Alat saada 3 - 5 minuutin mikrokyselyitämme parin päivän kuluessa sähköpostitse tai tekstiviesteillä. Etkö ole vielä valinnut tekstiviestillä saatavia kyselyitä? Voit muuttaa viestintäasetuksiasi milloin tahansa InCrowd-profiilissasi.",
    'confirmation.validation_error.actions_subtitle': "Käytä ruudun oikeassa alareunassa olevaa keskusteluikkunaa keskustellaksesi InCrowdin jäsenen kanssa ja selvittääksesi ongelma.",
    'confirmation.referral.info.1': "Kun olet täyttänyt toisen kyselysi, %{payoutBusinessDays} arkipäivän kuluessa sinä sekä sivustoa sinulle suositellut henkilö <saatte kumpikin {referralBonusAmount} %{currency}%>. Tuo {referralBonusAmount} %{currency}% lisätään palkkiotilillesi. Voit kirjautua <profiiliisi> koska tahansa ja päivittää asetuksiasi, tarkastella palkkioitasi sekä päästä käsiksi kaikkiin avoimiin kyselyihin, joihin sinut on kutsuttu.",
    'confirmation.referral.info.2': "Onko sinulla kysyttävää? <Chattaile kanssamme>",

    // REGISTRATION FOOTER
    'regftr.qualified.title': "Voitko sinä liittyä?",
    'regftr.markets.accepting': "InCrowd Answers hyväksyy tällä hetkellä:",
    'regftr.peers.title': "Kaltaisesi ammattilaiset",
    'regftr.peers.subtitle': "Vertaile vastauksiasi kaltaistesi ammattilaisten kanssa ja opi heidän vastauksistaan.",
    'regftr.invites.title': "Kutsut",
    'regftr.invites.subtitle': "Saat uusia kutsuja kyselyihin sähköpostitse tai puhelimeesi maksimoidaksesi tienestisi.",
    'regftr.earnings.title': "Tienestit",
    'regftr.earnings.subtitle': "Hallinnoi ja seuraa tienestejäsi ja maksutietojasi.",
    'regftr.stats.title': "Tilastot",
    'regftr.stats.subtitle': "Katso kaikkia kysely- ja käyttäjätietojasi.",

    'contextual_help.sms': "Saat tekstiviestillä ilmoituksen avoimista minikyselyistä. Tekstiviestien kautta pääset kyselyihin nopeammin sekä ansaitset enemmän palkintoja. Tietosi pysyvät yksityisenä ja niitä käytetään vain kyselykutsuihin.",
    'contextual_help.specialty': "Sisällytä vain erikoisalat, jotka on yhdistettu sinun NPI:hin, olet suorittanut toveruutta tai lääketieteen aloilla, jotka kuuluvat ensisijaiseen erikoisalaasi. Jos haluat tehdä muutoksia erikoisaloihisi tulevaisuudessa, ota yhteyttä osoitteeseen support@incrowdnow.com.",
    // USER
    'user(s)': "Käyttäjä |||| Käyttäjät",
    'user.login': "Kirjaudu sisään",
    'user.logout': "Kirjaudu ulos",
    'user.register': "Rekisteröidy",
    'user.invitations': "Kutsut",
    'user.email': "Sähköposti",
    'user.pass_word': "Salasana",
    'user.mobile': "Matkapuhelin",
    'user.mobile.hint': "Lisääthän maatunnuksen mukaan(+%{phoneCode} maalle %{countryName})",
    'user.title': "Titteli",
    'user.title_with_example': "Titteli (esim. Dr, Hra., Rva.)",
    'user.first_name': "Etunimi",
    'user.last_name': "Sukunimi",
    'user.middle_name': "Toinen nimi",
    'user.full_name': "%{firstName} %{lastName}",
    'user.full_name_and_title': "%{title} %{firstName} %{lastName}",
    'user.first_name_last_initial': "%{firstName} %{lastInitial}.",
    'user.anonymous': "Käyttäjä",
    'user.anonymous_admin': "Ylläpitäjä",
    'user.dashboard': "Ohjaamo",
    'user.profile': "Profiili",
    'user.profile.picture.upload': "Lataa profiilikuva",
    'user.profile.picture.change': "Muuta",
    'user.primary_lang': "Pääkieli",
    'user.primary_lang?': "Mikä on pääkielesi?",
    'user.survey_langs?': "Mitä kieliä puhut sujuvasti?",
    'user.notify_email': "Ilmoita sähköpostitse",
    'user.notify_mobile': "Ilmoita matkapuhelimeen",
    'user.contact_support': "Ota yhteys tukeen",
    // SATURN-9
    'user.contact_trouble': "Having trouble? Contact us below:",
    'user.contact_email': "Send us an email",
    // end SATURN-9
    'user.please_contact_us': "Ota meihin <contact us>.",
    'user.profession': "Ammatti",
    'user.profession?': "Mikä on ammattisi?",
    'user.join_now': "Liity nyt",
    'user.welcome_back': "Tervetuloa takaisin!",
    'user.not_a_member?': "Etkö ole jäsen?",
    'user.accept_terms': "Hyväksy ehdot",
    'user.accept_terms.yes': "Hyväksyn <terms and conditions>",
    'user.remember_me': "Muista minut tällä laitteella",
    'user.time_zone': "Aikavyöhyke",
    'user.payment.policy': "Aina, kun palkkiosi saavuttavat 25%{currency} rajan, sinulle ilmoitetaan ja voit valita maksutavan InCrowd-profiilissasi. Kysyttävää? Ota meihin yhteyttä alla olevan chat-ikkunan kautta.",
    'user.country.live_work?': "Missä maassa asut ja työskentelet?",
    // FORMS
    'form.button.back': "Takaisin",
    'form.button.next': "Seuraava",
    'form.button.cancel': "Peruuta",
    'form.button.submit': "Lähetä",
    'form.button.continue': "Jatka",
    'form.button.close': "Sulje",
    'form.button.go!': "Aloita!",
    'form.button.complete!': "Täytä loppuun!",
    'form.button.update': "Päivitä",
    'form.button.finish': "Lopeta",
    'form.button.search': "Etsi",
    'form.button.end': "Lopeta",
    'form.search.no_matches': "Tuloksia ei löydetty",
    'form.confirm_email': "Vahvista sähköpostiosoite",
    'form.confirm_pass_word': "Vahvista salasana",
    'form.required_fields': "Vaaditut kentät",
    'form.nothing_selected': "Mitään ei ole valittu",
    'form.confirm_field': "Vahvista %{formFieldLabel}",
    'form.choice.n/a': "N/A",
    'form.choice.yes': "Kyllä",
    'form.choice.no': "Ei",
    'form.choice.blank_for_all': "Jätä tyhjäksi valitaksesi kaikki",
    'form.choices.select_all': "Valitse kaikki",
    'form.choices.deselect_all': "Tyhjennä kaikki",
    'form.field.private': "Yksityinen kenttä",

    // USER ERRORS
    'user.error.dup_email': "Toinen käyttäjä on jo rekisteröitynyt annetulla sähköpostiosoitteella. <Kirjaudu sisään sen sijaan?>",
    'user.error.dup_sms': "Toinen käyttäjä on jo rekisteröitynyt antamallasi puhelinnumerolla",
  }
})
